export default __webpack_public_path__ + "static/logo-light-dd80094d0db587db7e0f86c195821a7e.png";